import { yupResolver } from "@hookform/resolvers/yup";
import { LoadingButton } from "@mui/lab";
import { Autocomplete, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormHelperText, FormLabel, Grid, IconButton, MenuItem, Select, TextField, Typography } from "@mui/material"
import CloseIcon from "mdi-material-ui/Close";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { axiosInstance } from "src/network/adapter";
import { ApiEndPoints } from "src/network/endpoints";
import * as yup from 'yup'
import { toastError, toastSuccess } from "src/utils/utils";
import { CleaveNumberInput } from "src/@core/components/cleave-components";
import CustomFileUploads from "../common/CustomFileUploads";
import ReactQuill from 'react-quill'
const validationSchema = yup.object().shape({

    title: yup.string().trim().required('Title  is required'),

    description: yup.string().trim().required('description is required'),
    post: yup.mixed()
        .required("Media is required")
        .test("fileSize", "File size must be 50MB or less", (value) => {
            if (typeof value === "string") return true;
            return !value || value.size <= 1024 * 1024 * 50; // 50MB
        })
        .test("fileType", "Unsupported file format. Only PDFs and images (JPG, PNG) are allowed.", (value) => {
            if (typeof value === "string") return true;
            return !value || /(image\/(jpeg|jpg|png)|application\/pdf)/.test(value.type);
        }),

})

const Dialoglounge = (props) => {
    const { mode, open, toggle, dataToEdit, onSuccess, role } = props;

    console.log("role", role);
    const [loading, setLoading] = useState(false);
    const [dialogTitle, setDialogTitle] = useState('');

    const {
        control,
        handleSubmit,
        reset,
        setValue,
        formState: { errors }
    } = useForm({
        defaultValues: {
            title: '',
            description: ''
        },
        resolver: yupResolver(validationSchema),
        mode: 'onChange'
    })

    useEffect(() => {
        if (open) {
            setLoading(false);
            setDialogTitle(mode === "add" ? "Add Lounge" : "Edit Lounge");
            reset({
                title: dataToEdit?.title || '',
                description: dataToEdit?.description || '',
                post: mode === "edit" ? dataToEdit?.post || '' : '',
                // ...(mode === "edit" && { newsLetterId: dataToEdit?.newsletterId || '' })

            });
        }
    }, [dataToEdit, mode, open, reset]);

    const onSubmit = (data) => {
        console.log("data", data)
        let payload = new FormData();
        payload.append('title', data.title);
        payload.append('description', data.description);

        if (typeof data.post !== "string" && data.post) {
            payload.append('post', data.post);
        }

        setLoading(true);
        let apiInstance = null;

        apiInstance = axiosInstance
            .post(ApiEndPoints.LOUNGE.create, payload, {
                headers: { 'Content-Type': 'multipart/form-data' }
            })
        apiInstance
            .then((response) => response.data)
            .then((response) => {
                onSuccess();
                toastSuccess(response.message);
                toggle();
            })
            .catch((error) => {
                toastError(error)
            })
            .finally(() => {
                setLoading(false);
            })
    }

    return <>
        <Dialog open={open} fullWidth maxWidth='sm' scroll="paper">
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                {dialogTitle}
                <IconButton aria-label='close' onClick={toggle} sx={{ color: theme => theme.palette.grey[500] }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ pb: 8, px: { sx: 8, sm: 15 }, pt: { xs: 8, sm: 12.5 } }}>
                <form id="form" onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={4}>
                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <FormLabel htmlFor='title' error={Boolean(errors.title)}>Title</FormLabel>
                                <Controller
                                    name='title'
                                    control={control}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            id="title"
                                            value={value}
                                            onChange={onChange}
                                            placeholder='Enter Title'
                                            error={Boolean(errors.title)}
                                        />
                                    )}
                                />
                                {errors.title && (
                                    <FormHelperText sx={{ color: 'error.main' }}>
                                        {errors.title.message}
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>


                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <FormLabel htmlFor='description' error={Boolean(errors.description)}>Description</FormLabel>
                                <Controller
                                    name='description'
                                    control={control}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            id="description"
                                            value={value}
                                            onChange={onChange}

                                            placeholder='Enter description'
                                            error={Boolean(errors.description)}
                                        />
                                    )}
                                />
                                {errors.description && (
                                    <FormHelperText sx={{ color: 'error.main' }}>
                                        {errors.description.message}
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <FormLabel>Media</FormLabel>
                                <Controller
                                    name="post"
                                    control={control}
                                    render={({ field: { value, onChange } }) => (
                                        <CustomFileUploads
                                            multiple={false}
                                            subtitle="(Max file size 3mb)"
                                            minHeight="100px"
                                            files={value}
                                            onChange={onChange}
                                            title={"Add Image"}
                                            MediaUrl='http://103.204.189.64:4003'
                                        />
                                    )}
                                />
                                {errors?.post && (
                                    <FormHelperText sx={{ color: "error.main" }}>
                                        {errors?.post?.message}
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>
                    </Grid>
                </form>
            </DialogContent>
            {/* {mode !== 'view' && ( */}
            <DialogActions>
                <LoadingButton
                    size="large"
                    type="submit"
                    form="form"
                    variant="contained"
                    loading={loading}
                >
                    {mode === 'edit' ? 'Update' : 'Add'}
                </LoadingButton>
                <Button size="large" variant="outlined" onClick={toggle}>
                    Cancel
                </Button>
            </DialogActions>
            {/* )} */}

        </Dialog >
    </>
}

export default Dialoglounge
